function docappCartModifier(cart) {
    if (cart) {
        let modifiedCart = cart
        let customPriceTotal = 0
        let bundlePriceTotal = 0

        cart.items.forEach((item, index) => {
            // if this item is a customize product
            if (item.properties['_customPrice']) {
                customPrice = Number(item.properties['_customPrice']) * 100

                // modify item prices - add custom price
                modifiedCart.items[index].original_price = cart.items[index].original_price + customPrice
                modifiedCart.items[index].price = cart.items[index].price + customPrice // deprecated, but is being used by docapp
                modifiedCart.items[index].final_price = cart.items[index].final_price + customPrice

                // modify line prices - add custom price x item quantity
                modifiedCart.items[index].original_line_price = cart.items[index].original_line_price + customPrice * item.quantity
                modifiedCart.items[index].line_price = cart.items[index].line_price + +(customPrice * item.quantity) // deprecated, but is being used by docapp
                modifiedCart.items[index].final_line_price = cart.items[index].final_line_price + +(customPrice * item.quantity)

                customPriceTotal += customPrice * item.quantity

            } else if (item.properties['_bundleId']) {

                let bundleItemDiscount = Number(item.properties['_bundleLineDiscount']) / Number(item.properties['_bundleLineLength'])
                let bundleLineDiscount = item.quantity * bundleItemDiscount

                // modify item prices
                modifiedCart.items[index].original_price = cart.items[index].original_price - bundleItemDiscount
                // modifiedCart.items[index].price = cart.items[index].price - bundleItemDiscount // deprecated, but is being used by docapp
                modifiedCart.items[index].final_price = cart.items[index].final_price - bundleItemDiscount

                // modify line prices
                modifiedCart.items[index].original_line_price = cart.items[index].original_line_price - bundleLineDiscount
                modifiedCart.items[index].line_price = cart.items[index].line_price - bundleLineDiscount // deprecated, but is being used by docapp
                modifiedCart.items[index].final_line_price = cart.items[index].final_line_price - bundleLineDiscount

                bundlePriceTotal += bundleLineDiscount
                // console.log('bundlePriceTotal', bundlePriceTotal)
            }
        })

        // modify cart prices
        modifiedCart['original_total_price'] = cart.original_total_price + customPriceTotal - bundlePriceTotal
        modifiedCart['items_subtotal_price'] = cart.items_subtotal_price + customPriceTotal - bundlePriceTotal
        modifiedCart['total_price'] = cart.total_price + customPriceTotal - bundlePriceTotal

        return modifiedCart
    }
}

let codes = []

// update the list of codes whenever the app detects a discount code change
document.body.addEventListener('docapp-discount-applied', (e) => {
    codes = []
    e.discounts.forEach((disc) => {
        let code_obj = {}
        code_obj['code'] = disc.title
        code_obj['amount'] = disc.amount
        code_obj['discClass'] = disc.discountClass
        codes.push(code_obj)
    })
})

// custom checkout to use with the Discount on Cart app
const customCheckoutDocApp = async (event) => {
    event.preventDefault()
    const atcBtn = event.target
    const btnText = event.target.innerHTML
    event.target.classList.add('ajax-loading')
    event.target.innerHTML = '<div class="loading-spinner loading-spinner--in-btn"></div>'

    try {
        // fetch the current cart
        const cart = await fetch(`/cart.json`)
        const data = await cart.json()

        // get the app discounted cart
        let modifiedItems
        if (window['discountOnCartProApp'] && window['discountOnCartProApp'].getDiscountedCart()) {
            modifiedItems = await window.discountOnCartProApp.getDiscountedCart().items
            integrateDiscount(modifiedItems, data, atcBtn, btnText)
        } else {
            setTimeout(async () => {
                if (window['discountOnCartProApp'] && window['discountOnCartProApp'].getDiscountedCart()) {
                    modifiedItems = await window.discountOnCartProApp.getDiscountedCart().items
                    integrateDiscount(modifiedItems, data, atcBtn, btnText)
                } else {
                    setTimeout(async () => {
                        modifiedItems = await window.discountOnCartProApp.getDiscountedCart().items
                        integrateDiscount(modifiedItems, data, atcBtn, btnText)
                    }, 2000)
                }
            }, 1000)
        }
    } catch (error) {
        alert('cart: ' + error.message)
    }
}

const integrateDiscount = (modifiedItems, data, atcBtn, btnText) => {
    // calculate the discount allocations
    modifiedItems.forEach((item, index) => {
        // update the modifiedItems key to current cart item key
        item.key = data.items[index].key
        
        // check if the item is a custom item, if yes split the discounts
        if( data.items[index].properties['_customParent']) {
            // update the _customParent to item key
            data.items[index].properties['_customParent'] = data.items[index].key

            // get the line price for parent and addon
            const parentPrice = data.items[index].original_line_price

            // calculate and assign the discount allocations proportionately
            item['parent_discount'] = Math.round((parentPrice / item.original_line_price) * item.total_discount)
            item['addon_discount'] = item.total_discount - item['parent_discount']
            item['combined_discount'] = item['parent_discount']
        }

        // check if the item is part of a bundle, if yes calculate the combined bundle discount + order discount
        else if( data.items[index].properties['_bundleId']) {
            let bundleDiscount = item.price * item.quantity - item.original_line_price 
            item['combined_discount'] = item.total_discount + bundleDiscount
        }

        else {
            item['combined_discount'] = item.total_discount
        }
    })

    // build the payload object
    let cartData = {
        action: 'bundle-draft-order',
        items: JSON.stringify(data.items),
        codes: JSON.stringify(codes),
        app_items: JSON.stringify(modifiedItems),
    }

    // pass the payload to the custom checkout proxy
    $.ajax({
        type: 'POST',
        url: '/apps/integration',
        data: cartData,
        dataType: 'json',
        error: function (error) {
            e = JSON.parse(error.responseText)
            desc = e.description
            alert(desc)
            atcBtn.classList.remove('ajax-loading')
            atcBtn.innerHTML = btnText
        },
        success: function (data) {
            if (data.api === true) {
                if (data.url) {
                    window.location.href = data.url
                } else {
                    alert('Something went wrong. Please contact our customer support.')
                }
            } else {
                alert(data.msg)
            }
            atcBtn.classList.remove('ajax-loading')
            atcBtn.innerHTML = btnText
        },
    })
}
// custom checkout original
const customCheckout = async (event) => {
    event.preventDefault()
    const btnText = event.target.innerHTML
    event.target.classList.add('ajax-loading')
    event.target.innerHTML = '<div class="loading-spinner loading-spinner--in-btn"></div>'

    fetch(`/cart.js`)
        .then((response) => response.json())
        .then(function (data) {
            const cartData = {
                action: 'draft-order',
                items: JSON.stringify(data.items),
            }

            $.ajax({
                type: 'POST',
                url: '/apps/integration',
                data: cartData,
                dataType: 'json',
                error: function (error) {
                    e = JSON.parse(error.responseText)
                    desc = e.description
                    alert(desc)
                    event.target.classList.remove('ajax-loading')
                    event.target.innerHTML = btnText
                },
                success: function (data) {
                    if (data.api === true) {
                        if (data.url) {
                            window.location.href = data.url
                        } else {
                            alert('Something went wrong. Please contact our customer support.')
                        }
                    } else {
                        alert(data.msg)
                    }
                    event.target.classList.remove('ajax-loading')
                    event.target.innerHTML = btnText
                },
            })
        })
}

document.addEventListener('DOMContentLoaded', () => {
    const btnCartPage = document.querySelector('#cartform .checkout-col .button')
    if (btnCartPage) {
        if (window['discountOnCartProApp']) {
            btnCartPage.classList.remove('loading')
        } else {
            setTimeout(() => {
                btnCartPage.classList.remove('loading')
            }, 1500)
        }
    }
})
